import { scopeLabel } from "../Permissions/scope";

export const CONFIDENTIAL_ITEM = "confidential_data.read";

// Leituras que a permissão no grupo completa (sem nenhuma, ela não mostra nada).
// As horas valem por projeto: o texto diz em quais.
export const COMPLEMENTS = [
  { key: "contracts.read", label: "Contratos" },
  { key: "payment_schedules.read", label: "Cronogramas e valores" },
  { key: "tax_invoices.read", label: "NFs" },
  { key: "time_clock.read", label: "Ponto" },
  { key: "project_hours.read", label: "Horas", byProject: true },
];

/** O que a pessoa vê: nas leituras por projeto, em quais; `title` só quando os nomes não cabem. */
function readLabel(complement, item) {
  if (!complement.byProject || item.resource_ids == null) return { key: complement.key, label: complement.label };
  const { text, title } = scopeLabel(item);
  return { key: complement.key, label: `${complement.label} em ${text}`, title: title === text ? undefined : title };
}

/**
 * Quem tem "Ver dados confidenciais" no grupo, com as leituras que a completam, a
 * partir do GET /user-permissions/users.
 */
export function groupViewers(people, groupId) {
  return people
    .filter(({ items }) => items.some((i) => i.key === CONFIDENTIAL_ITEM && (i.resource_ids || []).includes(groupId)))
    .map(({ user, link_status, items }) => ({
      user,
      link_status,
      reads: COMPLEMENTS.flatMap((complement) => {
        const item = items.find((i) => i.key === complement.key);
        return item ? [readLabel(complement, item)] : [];
      }),
    }));
}

/** Opções do "Incluir pessoas": os colaboradores que ainda não estão no grupo. */
export function candidateOptions(people, members) {
  const memberIds = new Set(members.map((m) => m.user.id));
  return people
    .filter(({ user }) => !memberIds.has(user.id))
    .map(({ user }) => ({ value: user.id, label: user.name || `Colaborador #${user.id}`, hint: user.email || "" }));
}
